import { createSubtitlesCustomMenu } from './create-subtitles-custom-menu'
import { getBackgroundColorMenuItems } from './lib'

/**
 * Settings subtitles background color menu
 */
export const SettingsSubtitlesBackgroundColorMenu = createSubtitlesCustomMenu(
  'SettingsSubtitlesBackgroundColorMenu',
  'background_color',
  getBackgroundColorMenuItems
)
